/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * The relationship type of the account holder.
 */
export type AlipayAccountRelationship = typeof AlipayAccountRelationship[keyof typeof AlipayAccountRelationship];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AlipayAccountRelationship = {
  Parents: 'Parents',
  Siblings: 'Siblings',
  Other_Relatives: 'Other Relatives',
  Vendor: 'Vendor',
  Supplier: 'Supplier',
  Employee: 'Employee',
  Spouse: 'Spouse',
  Friends: 'Friends',
  Employer: 'Employer',
  Child: 'Child',
  Self: 'Self',
  Business_Partner: 'Business Partner',
  Agent: 'Agent',
  Creditor: 'Creditor',
  Others: 'Others',
} as const;
